export const STEALTH_PROTOCOL_VERSION = "1";
export const STEALTH_GLOBAL = "nlStealth";
export const STEALTH_SESSION_EVENT = "nlstealth:session";
